// extracted by mini-css-extract-plugin
export var download_link = "styles-module--download_link--d1e4d";
export var image_wrapper = "styles-module--image_wrapper--2c193";